import React from "react";
import Navbar from "../../common/Navbar/Navbar";
import Main from "./Main";

function Dashboard() {
  return (
    <div>
      <Navbar>
        <Main />
      </Navbar>
    </div>
  );
}

export default Dashboard;
